/*
 * @Author: 谷文 guwenwen@dongfangfuli.com
 * @Date: 2021-08-16 14:52:58
 * @LastEditors: 谷文 guwenwen@dongfangfuli.com
 * @LastEditTime: 2023-06-08 13:37:51
 * @FilePath: /fore-life-h5/Users/guwen/Desktop/gitCode/fore-life-pc/src/fetch/birthday.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { sendPost } from '@utils/request';

// 生日汇首页数据
export function getHomePageData(data) {
  const url = 'trade/birthdayContract/getHomePageData';
  return sendPost({ url, data });
}

// 品牌详情数据
export function getBrandDetailData(data) {
  const url = '/trade/birthdayContract/getBrandDetails';
  return sendPost({ url, data });
}

// 随心兑品牌小程序码
export function getBrandAppletsCode(data) {
  const url = '/wechat/brand/appletsCode';
  return sendPost({ url, data });
}

// 随心兑门店小程序码
export function getSalesroomCode(data) {
  const url = '/wechat/salesroom/appletsCode';
  return sendPost({ url, data });
}

// 新版品牌详情数据
export function getNewBrandDetailData(data) {
  const url = '/birthday/pc/brandDetail';
  return sendPost({ url, data });
}

// 随心兑搜索
export function storeSearch(data) {
  const url = '/birthday/pc/store/ambiguous/query';
  return sendPost({ url, data });
}

// 随心兑搜索
export function tabListQuery(data) {
  const url = '/birthday/pc/brand/goodsList';
  return sendPost({ url, data});
}
